if (!customElements.get('subscription-modal')) {
  const purchaseOptionsModal = document.querySelector('.purchase-options-modal')
  customElements.define(
    'subscription-modal',
    class SubscriptionModal extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="button"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.variantId = this.getAttribute(
          'data-product-variant-id'
        )
        this.variantPrice = this.getAttribute(
          'data-product-variant-price'
        )
        this.querySelector('.product-variant-id').setAttribute('value', this.variantId);

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';

        window.addEventListener('on-one-time-purchase', this.oneTimeOrderFlow.bind(this));
        this.submitButton.addEventListener('click', this.oneTimeOrderFlow.bind(this));
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      async oneTimeOrderFlow(event) {
        event.preventDefault()
        event.stopPropagation()
        const existingSellingPlanInput = purchaseOptionsModal.querySelector('[name=selling_plan]')
        if (existingSellingPlanInput) {
          existingSellingPlanInput.remove();
          return this.oneTimeOrderFlow(event);
        } else {
          return this.onSubmitHandler(event);
        }
      }

      onSubmitHandler(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        // this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            window.dispatchEvent(new CustomEvent("close-modal"));

            const existingSellingPlanInput = purchaseOptionsModal.querySelector('[name=selling_plan]')
            if (existingSellingPlanInput) {
              existingSellingPlanInput.remove();
            }

            const subscriberModalOptions = purchaseOptionsModal.querySelector('.subscriber-modal-options')
            if (subscriberModalOptions.classList.contains('hide')) {
              const sellingPlanInput = document.createElement('input');
              sellingPlanInput.setAttribute('type', 'hidden');
              sellingPlanInput.setAttribute('name', 'selling_plan');
              purchaseOptionsModal.form.appendChild(sellingPlanInput);
              purchaseOptionsModal.form.querySelector('[name=selling_plan]').value = document.querySelector(
                'input[name="not-subscriber-frequency"]:checked',
              ).value
            }
          });
        event.stopPropagation();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
